<template>
  <div id="search-options">
    <div id="annual-selector">
      <div id="select-title">取引時点</div>
      <a-select :value="value_from" class="selector" @change="handleChangeFrom">
        <a-select-option
          v-for="(item, index) in options"
          :key="index"
          :value="item"
        >
          {{ item }}
        </a-select-option>
      </a-select>
      ~
      <a-select :value="value_to" class="selector" @change="handleChangeTo">
        <a-select-option
          v-for="(item, index) in options"
          :key="index"
          :value="item"
        >
          {{ item }}
        </a-select-option>
      </a-select>
    </div>

    <!-- <div id="switch-wrap">
          追加モード：<a-switch size="small" v-model="selectOptions.enableAppendMode">
          </a-switch>
      </div>
      <div id="slider">
          <div id="slider-title">選択範囲：</div>
          <a-slider v-model="selectOptions.sliderVal" :min="sliderSetting.min" :max="sliderSetting.max"
              :marks="sliderSetting.marks" :step="null"></a-slider>
      </div> -->
  </div>
</template>

<script>
import { getAnnualList } from "@/api/annual";
export default {
  name: "ClickModeSelector",
  data() {
    return {
      sliderSetting: {
        min: 0,
        max: 30,
        marks: {
          0: "0 km",
          4: "4 km",
          8: "10 km",
          12: "12km",
          16: "16 km",
          20: "20 km",
          24: "24 km",
          30: "30 km",
        },
      },
      options: [],
      selected: 0,
      value_from: "",
      value_to: "",
      selectOptions: {
        sliderVal: 5,
        enableAppendMode: false,
      },
    };
  },
  methods: {
    // handleChange(val) {
    //   this.value = val;
    //   this.$bus.$emit("annual", val);
    // },
    handleChangeFrom(val) {
      this.value_from = val;
      // 整合性チェック
      if (this.value_from !== "" && this.value_to !== "") {
        if (Number(this.value_from) > Number(this.value_to)) {
          this.value_from = "";
          alert("取引時点（開始）は取引時点（終了）よりも前の年で指定ください");
        }
      }
      this.updateYear();
    },
    handleChangeTo(val) {
      this.value_to = val;
      // 整合性チェック
      if (this.value_from !== "" && this.value_to !== "") {
        if (Number(this.value_from) > Number(this.value_to)) {
          this.value_to = "";
          alert("取引時点（終了）は取引時点（開始）よりも後の年で指定ください");
        }
      }
      this.updateYear();
    },
    updateYear() {
      console.log("test", this.value_from, this.value_to);
      let value_from = null;
      value_from = this.value_from === "" ? "2000" : this.value_from;
      let value_to = null;
      value_to = this.value_to === "" ? "3000" : this.value_to;
      this.$bus.$emit("year", Number(value_from), Number(value_to));
    },
    _getAnnualList() {
      getAnnualList()
        .then((res) => {
          if (res.data.code == 200) {
            let annualList = res.data.data.annual_list;
            for (let i = 0; i < annualList.length; i++) {
              this.options.push(annualList[i].Annual);
            }
            this.value = this.options[0];
            this.$bus.$emit("annual", this.value);
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.msg);
        });
    },
  },
  created() {
    this._getAnnualList();
  },
  watch: {
    selectOptions: {
      handler(val) {
        setTimeout(() => {
          this.$bus.$emit("selectOptions", val);
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#search-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  bottom: 5px;
}

#switch-wrap {
  display: flex;
  align-items: center;
  position: relative;
}

#slider {
  width: 450px;
  display: flex;
  align-items: center;

  &-title {
    text-align: left;
    width: 80px;
  }
}

.ant-slider {
  margin-bottom: 16px;
  width: 400px;
}

#select-title {
  text-align: left;
}

#annual-selector {
  float: right;
  margin: 10px 0px;
}

.selector {
  width: 100px;
  font-size: 12px;
}
</style>
